import { SvgIcon } from '@material-ui/core'

export default function CollapseIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <g transform="translate(-2, -2)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.028 9.96444C18.028 9.55023 17.6922 9.21444 17.278 9.21444L14.7854 9.21444V6.7218C14.7854 6.30759 14.4496 5.9718 14.0354 5.9718C13.6212 5.9718 13.2854 6.30759 13.2854 6.7218V9.96444C13.2854 10.3787 13.6212 10.7144 14.0354 10.7144L17.278 10.7144C17.6922 10.7144 18.028 10.3787 18.028 9.96444Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.0354 18.0281C14.4496 18.0281 14.7854 17.6923 14.7854 17.2781L14.7854 14.7855L17.278 14.7855C17.6922 14.7855 18.028 14.4497 18.028 14.0355C18.028 13.6213 17.6922 13.2855 17.278 13.2855L14.0354 13.2855C13.6212 13.2855 13.2854 13.6213 13.2854 14.0355L13.2854 17.2781C13.2854 17.6923 13.6212 18.0281 14.0354 18.0281Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.96432 18.0281C9.55011 18.0281 9.21432 17.6923 9.21432 17.2781V14.7855H6.72168C6.30747 14.7855 5.97168 14.4497 5.97168 14.0355C5.97168 13.6213 6.30747 13.2855 6.72168 13.2855L9.96432 13.2855C10.3785 13.2855 10.7143 13.6213 10.7143 14.0355L10.7143 17.2781C10.7143 17.6923 10.3785 18.0281 9.96432 18.0281Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.97171 9.96444C5.97171 9.55023 6.30749 9.21444 6.72171 9.21444H9.21435L9.21435 6.7218C9.21435 6.30759 9.55013 5.9718 9.96435 5.9718C10.3786 5.9718 10.7143 6.30759 10.7143 6.7218L10.7143 9.96444C10.7143 10.3787 10.3786 10.7144 9.96435 10.7144L6.72171 10.7144C6.30749 10.7144 5.97171 10.3787 5.97171 9.96444Z"
                    fill="currentColor"
                />
            </g>
        </SvgIcon>
    )
}
